<template>
  <div class="invite-friends-dialog-wrapper">
    <DialogPopup
      :show="value"
      width="470px"
      :append-to-body="true"
    >
      <InviteFriedns @icon-click="close" />
    </DialogPopup>
  </div>
</template>
<script>
import DialogPopup from '@/components/DialogPopup'
import InviteFriedns from './index.vue'
export default {
  name: 'InviteFriednsDialog',
  components: {
    DialogPopup,
    InviteFriedns,
  },
  props: {
    value: Boolean
  },
  data() {
    return {}
  },
  methods: {
    close() {
      this.$emit('input', false);
    }
  }
}
</script>

<style lang="scss" scoped>

</style>